import { useEffect, useState } from 'react';
import _get from 'lodash/get';

export const useGeoLocation = () => {
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [
    isGeolocationPermissionGranted,
    setIsGeolocationPermissionGranted,
  ] = useState(true);
  const [
    isGeolocationAvailableInBrowser,
    setIsGeolocationAvailableInBrowser,
  ] = useState(true);

  const onSuccess = position => {
    setLatitude(_get(position, 'coords.latitude'));
    setLongitude(_get(position, 'coords.longitude'));
  };

  const onError = err => {
    console.error('Error retrieving your location', err);
  };

  const handleGetLocation = () => {
    navigator.geolocation.getCurrentPosition(onSuccess, onError);
  };

  const handlePermissionChange = result => {
    const permissionState = _get(result, 'target.state');
    if (permissionState === 'granted') {
      handleGetLocation();
    } else if (permissionState === 'denied') {
      setIsGeolocationPermissionGranted(false);
    }
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setIsGeolocationAvailableInBrowser(false);
      console.error('Geolocation is not supported by your browser');
      return undefined;
    }

    let permissionStatus;

    const checkPermissions = async () => {
      try {
        /**
         * execute @function handleGetLocation() to trigger permission popup
         */
        handleGetLocation();

        permissionStatus = await navigator.permissions.query({
          name: 'geolocation',
        });

        /**
         * Add a listener to track further changes on permission, this is important for cases where user has denied
         * permission for the first time but later grants the permission
         */
        permissionStatus.addEventListener('change', handlePermissionChange);
      } catch (error) {
        console.error('Error checking geolocation permissions:', error);
      }
    };

    checkPermissions();

    return () => {
      if (permissionStatus) {
        permissionStatus.removeEventListener('change', handlePermissionChange);
      }
    };
  }, []);

  return {
    canComputeLocation:
      isGeolocationAvailableInBrowser && isGeolocationPermissionGranted,
    latitude,
    longitude,
  };
};

export const getGeoLocation = (callback = () => {}) => {
  const onSuccess = position => {
    const latitude = _get(position, 'coords.latitude');
    const longitude = _get(position, 'coords.longitude');
    callback(latitude, longitude);
  };

  const onError = err => {
    callback(null, null);
    console.error('Error retrieving your location', err);
  };

  if (!navigator.geolocation) {
    console.error('Geolocation is not supported by your browser');
  } else {
    navigator.geolocation.getCurrentPosition(onSuccess, onError);
  }
};
